// 易花花运营下载页
export default [
  // 半流程推广下载落地页
  {
    path: '/yhh/download/semiprocess',
    name: 'yhh_download_semiprocess',
    component: () => import('@/pages/activity/download/yhh/semi-process'),
    meta: { title: '下载易花花' }
  },
  // 短信推广下载落地页
  {
    path: '/yhh/download/sms',
    name: 'yhh_download_sms',
    component: () => import('@/pages/activity/download/yhh/sms'),
    meta: { title: '下载易花花' }
  },
  // 速牛 登录页|首页
  {
    path: '/su-niu/home',
    name: 'su_niu_home',
    component: () => import('@/pages/activity/su-niu/home'),
    meta: { title: '易花花' }
  },
  // 速牛 下载页
  {
    path: '/su-niu/download',
    name: 'su_niu_download',
    component: () => import('@/pages/activity/su-niu/download'),
    meta: { title: '下载易花花' }
  }
]
